import type { SettingsTab } from '@/lib/constants';

import { SETTINGS_TABS } from '@/lib/constants';

export const INTEGRATION_TYPES = {
  API: 'api',
  LINEAR: 'linear',
  JIRA: 'jira',
  ASANA: 'asana',
  MCP: 'mcp',
  MCP_SERVERS: 'mcp-servers',
  CLI: 'cli',
  SLACK: 'slack',
  NOTION: 'notion',
  CONFLUENCE: 'confluence',
  CURSOR_CLOUD_AGENT: 'cursor-cloud-agent',
  GITHUB_ISSUES: 'github-issues',
  POSTHOG: 'posthog',
  SENTRY: 'sentry',
  DATADOG: 'datadog',
  CHATGPT_PLAN: 'chatgpt-plan',
} as const;

export type IntegrationType = (typeof INTEGRATION_TYPES)[keyof typeof INTEGRATION_TYPES];

// Every `integration` URL value that opens a page. Retired values that docs and bookmarks
// still link to map to the page that replaced them.
const INTEGRATION_BY_URL_VALUE = new Map<string, IntegrationType>([
  ...Object.values(INTEGRATION_TYPES).map((type) => [type, type] as const),
  ['analytics', INTEGRATION_TYPES.API],
]);

/** The page an `integration` URL value opens, or null when it names none. */
export function resolveIntegration(urlValue: string | null): IntegrationType | null {
  return urlValue ? (INTEGRATION_BY_URL_VALUE.get(urlValue) ?? null) : null;
}

// The pages for using cubic from your own tools belong to you, so API, CLI & MCP lists them.
const API_CLI_PAGES: ReadonlySet<IntegrationType> = new Set([
  INTEGRATION_TYPES.API,
  INTEGRATION_TYPES.CLI,
  INTEGRATION_TYPES.MCP,
]);

/** The settings tab whose list leads to an integration's page. */
export function settingsTabForIntegration(page: IntegrationType): SettingsTab {
  return API_CLI_PAGES.has(page) ? SETTINGS_TABS.API_CLI : SETTINGS_TABS.INTEGRATIONS;
}
